import { TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { PackageFilterFormPaginated } from 'features/package/components/package-filter-form/type';
import { usePermissions } from 'features/users';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { Package } from 'types/package';
import { UserWithithdraw } from 'types/withdraw';

type UsersWithWalletTableProps = {
  isLoading: boolean;
  data: any;
  tableParams: PackageFilterFormPaginated;
  updateParams: Dispatch<SetStateAction<PackageFilterFormPaginated>>;
};

export const BookingViewTable = ({
  data,
  isLoading,
  tableParams,
  updateParams,
}: UsersWithWalletTableProps) => {
  const permissions = usePermissions();
  const navigate = useNavigate();
  if (!permissions) return null;

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<UserWithithdraw> | SorterResult<UserWithithdraw>[],
  ) => {
    const sortBy = () => {
      if (Array.isArray(sorter)) return;

      const sortOrder =
        sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;

      if (sorter?.field === 'last_transaction_date') {
        return {
          order_by_balance: undefined,
          order_by_transaction: sortOrder,
        };
      }
    };

    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      ...sortBy(),
    });
  };

  const dataSource = Array.isArray(data) ? data : [];

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge text={'Total'} />
      </StyledTableHeader>
      <Table<Package>
        loading={isLoading}
        dataSource={dataSource}
        rowKey='id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: data?.total || 0,
        }}
        onRow={(record: any) => {
          return {
            onClick: () => {
              const selection = window?.getSelection()?.toString();
              if (!selection?.length) {
                navigate(
                  getRoute(ROUTES.booking_Calculation_details, record.id),
                );
              }
            },
          };
        }}
      >
        <Column title={'Model'} dataIndex={'name'} />
        <Column title={'Facility Name'} dataIndex={'facilityName'} />
        <Column title={'Field Name'} dataIndex={'fieldName'} />
        <Column title={'Commission Value'} dataIndex={'commissionPercentage'} />
        <Column title={'Note'} dataIndex={'notes'} />
      </Table>
    </StyledTableWrapper>
  );
};
